import { useQuery } from '@apollo/client/react';
import { GET_TEAM_TAB_DATA, TeamType } from 'domain/shared/newProject';
import { NetworkStatus } from '@apollo/client';

export const useTeam = (projectId: string | number | undefined) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{ baseProject: TeamType }>(GET_TEAM_TAB_DATA, {
    variables: { id: projectId?.toString() },
    skip: !projectId,
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  });

  return {
    data: data?.baseProject,
    loading,
    error,
    refetch,
    isDataReloading: !data || networkStatus !== NetworkStatus.ready,
  };
};
